import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BaseFlakeInfos } from '@/services/balancer/subgraph/types';
import Activities from './FlakeActivities/Activities.vue';
/**
 * TYPES
 */
type Props = {
  userLeaveRequestsQuery: any;
  baseFlakeInfos: BaseFlakeInfos[];
  loading: boolean;
};

/**
 * PROPS
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default _defineComponent({
  props: {
    userLeaveRequestsQuery: { type: null, required: true },
    baseFlakeInfos: { type: Array, required: true },
    loading: { type: Boolean, required: true, default: false }
  } as unknown as undefined,
  setup(__props: {
  userLeaveRequestsQuery: any;
  baseFlakeInfos: BaseFlakeInfos[];
  loading: boolean;
}) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Activities, {
    loading: __props.loading,
    baseFlakeInfos: __props.baseFlakeInfos,
    userLeaveRequestsQuery: __props.userLeaveRequestsQuery
  }, null, 8, ["loading", "baseFlakeInfos", "userLeaveRequestsQuery"]))
}
}

})